module.exports = __webpack_public_path__ + "img/bannerPc-2-5.c3e4eaf5.png";